import { render, staticRenderFns } from "./TheHeader.vue?vue&type=template&id=ec9daf82&scoped=true"
var script = {}
import style0 from "./TheHeader.vue?vue&type=style&index=0&id=ec9daf82&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec9daf82",
  null
  
)

export default component.exports